import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { vovSharedService } from '../shared/services/vov-shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  [x: string]: any;
  public headerName: string;
  public open: boolean = false;
  public notOpen: boolean = true;
  signInForm: FormGroup;
  resetPasswordForm: FormGroup;
  public activeParam;
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;


  constructor(
    private formBuilder: FormBuilder,
    private vovSharedService: vovSharedService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private activeRouter: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', Validators.required]
    });

    // this.resetPasswordForm = this.formBuilder.group({
    //   password: ['', [Validators.required, Validators.minLength(6)]],
    //   confirmPassword: ['']
    // }, { validator: this.checkPasswords });
    this.activeRouter.params.subscribe(params => {
      console.log(params, 'param')
      this.activeParam = params;
    })
  }

  onSubmit() {
    this.open = true;
    //this.notOpen = false;
    console.log('confirmation email');
    this.vovSharedService.passwordEmailConfirmation(this.forgotPasswordForm.value).subscribe((res) => {
      if (res && res.message) {
        this.formGroupDirective.resetForm();
        this.forgotPasswordForm.reset();
        this._snackBar.open('Success :' + res.message, '', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
      }
      this.forgotPasswordForm.reset();
    }, error => {
      let errorMessage = error.error.message ? error.error.message : error;
      this._snackBar.open('' + errorMessage, '', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right',
        panelClass: 'error-snackbar'
      });
    })
  }



  checkPasswords(group: FormGroup) {
    let pass = group.controls.password.value;
    let confirmPass = group.controls.confirmPassword.value;
    return pass === confirmPass ? null : { notSame: true }
  }


  goBack() {
    this.open = false;
    this.notOpen = true;
  }

  goBackToLogin() {
    if (Object.keys(this.activeParam).length > 0) {
      return this.router.navigate(['/login', this.activeParam]);
    } else {
      return this.router.navigate(['/code-sign-in']);
    }
  }
}

